<template>
  <div>
    <form-input-label :value="trans('__JSON__.Packages')" />
    <div class="border p-2">
      <expander
        v-for="(form, index) in forms"
        :key="form.id"
        :title="get(form, `name.${currentLocale}`) || get(form, 'name.en') || trans('__JSON__.New Package')"
      >
        <template #content>
          <form-translatable-input
            :id="`partner-package-name-${index}`"
            type="text"
            name="name"
            v-model="form.name"
            container-class="form-group"
            :label-text="trans('common.name')"
            :placeholder="trans('common.name')"
            :error-key="`packages.${index}.name`"
            :errors="errors"
          ></form-translatable-input>
          <form-translatable-input
            :id="`partner-package-description-${index}`"
            type="textarea"
            v-model="form.description"
            container-class="form-group"
            :label-text="trans('__JSON__.Description')"
            :placeholder="trans('__JSON__.Description')"
            :help-text="trans('__JSON__.The description can have multiple values separated by a new line.')"
            :error-key="`packages.${index}.description`"
            :errors="errors"
          ></form-translatable-input>
          <form-input
            :id="`partner-package-price-${index}`"
            type="text"
            name="price"
            v-model="form.price"
            container-class="form-group"
            :label-text="trans('__JSON__.Price')"
            :placeholder="trans('__JSON__.Price')"
            :error="get(errors, `packages.${index}.price`)"
          ></form-input>
          <form-input
            :id="`partner-package-link-${index}`"
            type="text"
            name="link"
            v-model="form.link"
            container-class="form-group"
            :label-text="trans('__JSON__.Link')"
            :placeholder="trans('__JSON__.Link')"
            :error="get(errors, `packages.${index}.link`)"
          ></form-input>
          <form-input
            :id="`partner-package-monthly-${index}`"
            type="checkbox"
            name="monthly"
            v-model="form.is_price_monthly"
            container-class="form-group"
            :label-text="trans('__JSON__.Monthly')"
            :placeholder="trans('__JSON__.Monthly')"
            :error="get(errors, `packages.${index}.is_price_monthly`)"
          ></form-input>
          <form-input
            :id="`partner-package-published-${index}`"
            type="checkbox"
            name="published"
            v-model="form.is_published"
            container-class="form-group"
            :label-text="trans('__JSON__.Is published')"
            :placeholder="trans('__JSON__.Is published')"
            :error="get(errors, `packages.${index}.is_published`)"
          ></form-input>
          <div class="flex justify-content-end m-2">
            <button type="button" class="button button_danger" @click="removePackage(index)">
              {{ trans('__JSON__.Remove Package') }}
            </button>
          </div>
        </template>
      </expander>
      <div class="flex justify-content-end m-2">
        <button type="button" class="button" @click="addPackage">{{ trans('__JSON__.Add Package') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import Expander from '@/components/Dashboard/Expander.vue';
import FormInput from '@/components/Shared/Form/Input/Index.vue';
import FormInputLabel from '@/components/Shared/Form/Input/Label.vue';
import FormTranslatableInput from '@/components/Shared/Form/Input/Translatable.vue';
import { reactive, watch } from 'vue';
import { useLocales } from '@/composables/locales';
import { get } from 'lodash';

const { packages } = defineProps({
  packages: {
    type: Array,
    required: true,
  },
  errors: {
    type: Object,
  },
});

const emit = defineEmits(['update:packages']);

const forms = reactive(packages);

const currentLocale = useLocales().currentLocale;

watch(
  forms,
  forms => {
    emit('update:packages', forms);
  },
  { deep: true },
);

const addPackage = () => {
  forms.push({
    id: null,
    name: null,
    description: null,
    price: '',
    link: '',
    monthly: false,
  });
};

const removePackage = index => {
  forms.splice(index, 1);
};
</script>
